module.exports = __webpack_public_path__ + "static/media/world-vote.c6e39af2.png";